import React from 'react'
import PropTypes from 'prop-types'
//import { Link } from 'react-router-dom'


export default function Navbar(props) {
    return (
        <>
            <nav className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}>
                <div className="container-fluid">
                    <a className="navbar-brand" href="#" ></a>

                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="navbar-nav"  >
                            <li className="nav-item" >
                                <a className="nav-link active" aria-current="page" >{props.title}</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#" >Home</a>
                            </li>
                            {/* <li className="nav-item" >
                                <a className="nav-link" href="/about" >{props.aboutText}</a>
                            </li> */}
                            


                        </ul>
                        <div className={`form-check form-switch text-${props.mode==='light'?'dark':'light'}`} >
                            <input className="form-check-input"onClick={props.hrefggleMode} type="checkbox" role="switch" id="flexSwitchCheckDefault" />
                            <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Enable Dark Mode</label>
                        </div>

                    </div>
                </div>
            </nav>
        </>
    )
}
